import { PageContent } from 'restaurantAdmin/layout/PageContent';
import { PageHeader } from 'restaurantAdmin/layout/PageHeader';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { OPERATIONS_MESSAGING_PATH } from 'restaurantAdmin/paths';
import { getMessagingTemplates } from './apiHelpers';
import { useQuery } from '@tanstack/react-query';
import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { LoadingPage } from '@components/LoadingPage';

export const MessagingPage = () => {
  const { id: restaurantId } = useRestaurant();
  const navigate = useNavigate();

  const { data: templates, isLoading } = useQuery({
    queryKey: ['messagingTemplates', restaurantId],
    queryFn: () => getMessagingTemplates(restaurantId),
  });

  useEffect(() => {
    if (!templates || templates.length === 0) {
      return;
    }

    navigate(`${OPERATIONS_MESSAGING_PATH}/${templates[0].id}`);
  }, [templates]);

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <>
      <PageHeader title="Message Templates" category="Operations"></PageHeader>
      <PageContent>
        <p>No templates found. Try refreshing the page.</p>
      </PageContent>
    </>
  );
};
